import React from 'react'
import { SVGProps } from 'react'

export const AlertIcon = (props: SVGProps<SVGSVGElement>): React.ReactNode => (
  <svg
    width="65"
    height="65"
    viewBox="0 0 65 65"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M36.1111 36.1111H28.8889V14.4444H36.1111V36.1111ZM32.5 51.6389C31.255 51.6389 30.0609 51.1443 29.1805 50.2639C28.3001 49.3835 27.8056 48.1895 27.8056 46.9444C27.8056 45.6994 28.3001 44.5053 29.1805 43.625C30.0609 42.7446 31.255 42.25 32.5 42.25C33.745 42.25 34.9391 42.7446 35.8195 43.625C36.6999 44.5053 37.1944 45.6994 37.1944 46.9444C37.1944 48.1895 36.6999 49.3835 35.8195 50.2639C34.9391 51.1443 33.745 51.6389 32.5 51.6389ZM45.9694 0H19.0306L0 19.0306V45.9694L19.0306 65H45.9694L65 45.9694V19.0306L45.9694 0Z"
      fill="#B2242A"
    />
  </svg>
)
